import styles from './Dashboard.module.css';

import { Patrollers } from '../Patrollers/Patrollers';
import { Certifications } from '../Certifications/Certifications';

export const Dashboard = () => {
    return (
        <div className={ styles.dashboard }>
            <Patrollers />
            
            <Certifications />
        </div>
    );
};